export default __webpack_public_path__ + "1174df44c98922a744b5a468bc14f1e5.svg";